import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { tokens } from '../../../theme'
import MoreVertIcon from '@mui/icons-material/MoreVert';

function AdminBox({ admin, updateAdmin, updateAdminPassword, removeAdmin }) {
    const colors = tokens();
    const [selectedLanguage, setSelectedLanguage] = useState("turkish");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box width="700px">
            <Menu
                id="menu"
                aria-labelledby="open-menu-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem onClick={() => {
                    handleClose();
                    updateAdmin(admin);
                }}>
                    Düzenle
                </MenuItem>
                <MenuItem onClick={() => {
                    handleClose();
                    updateAdminPassword(admin);
                }}>
                    Şifreyi Değiştir
                </MenuItem>
                <MenuItem onClick={() => {
                    handleClose()
                    removeAdmin(admin);
                }}>
                    Sil
                </MenuItem>
            </Menu>
            <Box position="relative" bgcolor={colors.grey[900]} p="20px" borderRadius="10px">
                <Box position="absolute" top={15} right={15}>
                    <IconButton
                        id="open-menu-button"
                        aria-controls={open ? 'menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>
                        <MoreVertIcon sx={{ scale: "1.2" }} />
                    </IconButton>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography variant='h3' fontWeight="600">
                        {admin.username ? admin.username : "-"}
                    </Typography>
                </Box>
                <Box component="hr" my="20px" border={"1px solid " + colors.grey[500]} />
                <Box mt="10px">
                    <Box display="flex" justifyContent="space-between" mt="10px">
                        <Box>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Kullanıcılar Sayfası İzni:</b> {admin.users_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Kanji Sayfası İzni:</b> {admin.contents_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Bildirim Gönderme İzni:</b> {admin.notifications_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Kopyalama İzni:</b> {admin.copy_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Yöneticiler Sayfası İzni:</b> {admin.admins_perm ? "Var" : "Yok"}</Typography>
                        </Box>
                        <Box>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-SSS Sayfası İzni:</b> {admin.faqs_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-Mesajlar Sayfası İzni:</b> {admin.contact_messages_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-İçerik Silme İzni:</b> {admin.content_deletion_perm ? "Var" : "Yok"}</Typography>
                            <Typography variant='h6' ><b style={{ marginRight: "5px" }}>-İçerik Dili:</b> {admin.permitted_language ? (admin.permitted_language).toUpperCase() : "Tümü"}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default AdminBox